import { t } from "../i18n/strings";

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * How long ago something happened, in words.
 *
 * The timestamps carry their timezone (adminbackapi puts it back on before answering), so
 * Date parses them without guessing.
 */
export function getRelativeTime(value: string, now: number = Date.now()): string {
  const elapsed = now - new Date(value).getTime();

  if (elapsed < MINUTE) {
    return t("time.justNow");
  }
  if (elapsed < HOUR) {
    return t("time.minutes", { count: Math.floor(elapsed / MINUTE) });
  }
  if (elapsed < DAY) {
    return t("time.hours", { count: Math.floor(elapsed / HOUR) });
  }
  return t("time.days", { count: Math.floor(elapsed / DAY) });
}

/** Full moment, for the places where "3 дн назад" is not precise enough. */
export function getDateTime(value: string): string {
  const date = new Date(value);
  return date.toLocaleString("ru-RU", { dateStyle: "short", timeStyle: "short" });
}
